import React from 'react';
import { v4 as uuidv4 } from 'uuid';
const InputSelectBox = ({errors, Label, elementName, handleRegChange, value, arrOptions, type}) => {
  return <div>
    <label htmlFor="dropdown" className="block text-sm font-medium text-label-clr pl-1">
        {Label}
    </label>
      <select
        key={ elementName == "EventName" ? "EventId" : uuidv4() }
        id={elementName}
        name={elementName}
        value={value}
        onChange={handleRegChange}
        className="bg-input-bg mt-1 block w-full px-3 py-3 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
      >
        <option value="">Select an option</option>
        {arrOptions.map((obj, index) => (
            <option value={elementName == "EventName" ? obj.EventId : elementName == "EventType" ?  obj.EventDetailsId : obj[type]} key = {uuidv4()} datakey={elementName == "EventName" ? obj.EventId :uuidv4()}>{obj[type]}</option>
        ))}
      </select>
        {errors && (
            <p className="text-red-500 text-sm mt-1">{errors}</p>
        )}
    </div>;
};

export default InputSelectBox;